/* ==========================================================================
   POSSEN — Pants Event
   Two jobs, both on markup Liquid already rendered:

   1. Product page: when the shopper picks another style, show that style's
      tier prices — or the "choose Chino, 5-pockets…" line when the style is
      not in the event. The tier prices for every eligible variant arrive as
      JSON from snippets/pants-event-product.liquid.
   2. Cart: cart-modern.js re-renders the meter after each change; fill in
      the step that change just reached, so the progress is felt, not read.

   No copy lives here — Langify only translates what Liquid renders.
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------ product */

  function initProduct() {
    var root = document.querySelector('[data-pants-event-product]');
    if (!root) return;

    var on = root.querySelector('[data-pe-on]');
    var off = root.querySelector('[data-pe-off]');
    var prices = root.querySelectorAll('[data-pe-price]');
    var tiersByVariant;
    try {
      tiersByVariant = JSON.parse(root.querySelector('[data-pe-variants]').textContent);
    } catch (error) {
      return;
    }

    var current = null;

    function selectedVariantId() {
      // selectCallback() in templates/product.liquid keeps #variant-selected
      // in sync with whichever picker the shopper used.
      var field = document.getElementById('variant-selected');
      if (field && field.value) return String(field.value);
      var picked = document.querySelector('.selectsizes-options li.selected[data-variant]');
      if (picked) return String(picked.getAttribute('data-variant'));
      var match = /[?&]variant=(\d+)/.exec(window.location.search);
      return match ? match[1] : null;
    }

    function update() {
      var id = selectedVariantId();
      if (!id || id === current) return;
      current = id;

      var tiers = tiersByVariant[id];
      if (tiers) {
        for (var i = 0; i < prices.length; i++) {
          var index = Number(prices[i].getAttribute('data-pe-price'));
          if (tiers[index]) prices[i].textContent = tiers[index];
        }
      }
      on.hidden = !tiers;
      off.hidden = !!tiers;
    }

    function soon() {
      window.setTimeout(update, 0);
    }

    // The theme's picker calls stopPropagation() and sets the hidden field
    // with jQuery .val(), which fires nothing. So watch the picker's own
    // "selected" class, and listen in the capture phase as a backstop.
    var picker = document.getElementById('product-variants');
    if (picker && 'MutationObserver' in window) {
      new MutationObserver(soon).observe(picker, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'value', 'selected']
      });
    }
    ['click', 'touchend', 'change'].forEach(function (type) {
      document.addEventListener(type, soon, true);
    });
    window.addEventListener('popstate', soon);

    update();
  }

  /* --------------------------------------------------------------- cart */

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pairsInMeter() {
    var steps = document.querySelector('[data-pants-event-meter] [data-pe-pairs]');
    return steps ? Number(steps.getAttribute('data-pe-pairs')) || 0 : null;
  }

  function initCart() {
    if (!document.querySelector('[data-pants-event-meter]')) return;
    var previous = pairsInMeter();

    document.addEventListener('cart:updated', function () {
      var now = pairsInMeter();
      if (now === null) return;

      if (!reduceMotion && previous !== null && now > previous) {
        var steps = document.querySelectorAll('[data-pants-event-meter] .PantsEventMeter__step');
        var order = 0;
        for (var i = previous; i < Math.min(now, steps.length); i++) {
          steps[i].style.setProperty('--pe-i', order++);
          steps[i].classList.add('is-entering');
        }
      }
      previous = now;
    });
  }

  /* ------------------------------------------------------------- strip */

  // The homepage's brand header is fixed and transparent over the hero, so it
  // would cover the strip. Hold it just below the strip and let it rise with
  // it as the page scrolls, reaching the top exactly when the strip has gone.
  // Every other page clears its header with #main's margin (setMarginTop in
  // the layouts) and is left alone. Same selector as the CSS in
  // pants-event.css, which covers the first frame before this runs.
  function initStrip() {
    var bar = document.querySelector('.PantsEventBar');
    if (!bar || !document.body.classList.contains('template-index')) return;

    var headers = Array.prototype.filter.call(document.querySelectorAll('header.header--brand-home'), function (header) {
      return getComputedStyle(header).position === 'fixed';
    });
    if (!headers.length) return;

    var barBottom = 0;
    var queued = false;

    function measure() {
      barBottom = bar.getBoundingClientRect().bottom + window.scrollY;
    }

    function place() {
      queued = false;
      var offset = Math.max(0, Math.round(barBottom - window.scrollY));
      headers.forEach(function (header) {
        header.style.top = offset + 'px';
      });
    }

    function schedule() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(place);
    }

    measure();
    place();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', function () {
      measure();
      schedule();
    });
  }

  function init() {
    initStrip();
    initProduct();
    initCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
